<template>
  <section class="page about">
    <div class="container">
      <div class="about__content">
      <h1 class="page-title">Sobre</h1>
      <div class="about__bio">
        <p>O artista Gaudêncio de Sousa Ferreira nasceu em José da Penha, RN em 1972. Inicia-se na pintura ainda menino (1985) influenciado pela sua mãe que praticava pintura em tecido e pelo irmão mais velho que era artista publicitário.</p>
        <p>Procurando novos horizontes, muda-se para São Paulo em 1990, momento em que adota o nome artístico SOUSA BRANCO. Começa a estudar desenho e pintura acadêmica com o artista plástico Miguel Mendes Victorio em Atibaia no interior de são Paulo, onde também pratica pintura ao ar livre e participa de concursos regionais obtendo premiações em alguns. Em São Paulo, aos poucos, começa a se integrar com a cultura da cidade grande, mas sem abandonar suas raízes regionais.</p>
        <p>A partir de 1995 muda-se para a cidade de Jundiaí (SP) e recebe influencia de outros pintores como Monteiro Prestes (pintura clássica) e Álvaro Lima (Pintura impressionista) e participa de exposições regionais, sendo destaque em algumas.</p>
        <p>Mantem-se ausente de exposições, mas segue desenvolvendo seu trabalho através de diversas pesquisas e estudos. Na busca de uma forma própria, a partir de 2005 começa a fazer experiências cubistas.</p>
        <p>Em 2011, estabelece uma temática cultural em seus quadros, explorando as diversas regiões brasileiras. Nas suas obras, hora coloridas, hora monocromáticas, anda por diversos matizes e “brinca” com suaves transparências.</p>
        <p>A principal característica de seu trabalho é a atividade cotidiana do homem que é explorada poeticamente em suas obras.</p>
      </div>
      </div>
      <div class="about__image-container about__image-container--2">
        <div class="about__image-decor about__image-decor--1">&nbsp;</div>
        <img src="@/assets/img/gallery/gallery1.jpg" alt="" class="about__image about__image--2" />
        <div class="about__image-decor about__image-decor--2">&nbsp;</div>
    </div>
    </div>
    <div class="about__image-container about__image-container--1">
      <img src="@/assets/img/sousaFoto.jpg" alt="" class="about__image about__image--1" />
    </div>
    <decoration-bg v-if="screenType != 'phone' && screenType != 'tab-port' " routePath="about" />
    
  </section>
</template>
<script>
import { respondMixin } from "../misc/mixins";
import DecorationBg from "@/components/DecorationBg.vue";

export default {
  components: {
    "decoration-bg": DecorationBg,
  },
  mixins: [respondMixin],
};
</script>
<style lang="scss">
.about {
  padding-bottom: 10rem;

  @include respond(tab-port) {
    padding-left: 5%;
    padding-right: 5%;
  }

  &__content {
    z-index: 10;
    position: relative;

    @include respond(tab-port) {
      z-index: initial;
    }

    @include respond(big-desk) {
      height: 110vh;
    }
  }

  &__bio {
    padding: 5rem 0 0 8rem;
    width: 55%;
    line-height: 1.7;
    position: relative;

    & p {
      margin-bottom: 3rem;
    }

    &::after {
      content: "";
      display: block;
      width: 0.3rem;
      height: 8rem;
      background-color: $color-wine;
      position: absolute;
      top: 5.3rem;
      left: 5.5rem;
    }

    @include respond(tab-port) {
      padding-top: 43rem;
      width: 100%;
      margin: 0 auto;
      padding-left: 0;

      &::after {
        transform: rotate(90deg);
        top: 0;
        left: 4rem;
      }
    }
  }

  &__image-container {
    position: absolute;

    &--1 {
      overflow: hidden;
      top: 12rem;
      right: -10rem;
      width: 45%;
      transform: skewX(20deg);
      height: 40rem;

      & > * {
        transform: skewX(-20deg);
      }

      @include respond(tab-port) {
        width: 90%;
        right: 5%;
        transform: skewX(0deg);
        top: 18rem;

        & > * {
          transform: skewX(0deg);
        }
      }

      @include respond(big-desk) {
        right: -10%;
        top: 10%;
      }
    }

    &--2 {
      width: 35rem;
      height: 35rem;
      right: 0;
      bottom: 7rem;

      @include respond(tab-port) {
        position: static;
        width: 100%;
        height: auto;
      }
    }
  }

  &__image {
    &--1 {
      height: 100%;
      position: absolute;
      top: 0;
      right: 60%;
      transform: translateX(50%) skewX(-20deg);

      @include respond(tab-port) {
        width: 100%;
        height: auto;
        left: 0;
        transform: skew(0);
      }

      @include respond(big-desk) {
        right: 70%;
      }
    }

    &--2 {
      height: 100%;

      @include respond(tab-port) {
        width: 100%;
        height: auto;
      }
    }
  }

  &__image-decor {
    position: absolute;
    height: 4rem;
    width: 4rem;

    @include respond(tab-port) {
      display: none;
    }

    &::before,
    &::after {
      content: "";
      display: block;
      width: 0.5rem;
      height: 4rem;
      background-color: $color-wine;
      position: absolute;
    }

    &::before {
      top: 0;
      right: 0;
      transform: rotate(90deg);
      transform-origin: 0 0;
    }

    &::after {
      top: 0;
      right: 0;
    }

    &--1 {
      top: -2rem;
      right: -1rem;
    }

    &--2 {
      transform: rotate(180deg);
      bottom: -2rem;
      left: -2rem;
    }
  }
}
</style>
